// DS: i3.39 Studio Draft
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioDraft: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 3a1 1 0 0 0-1 1v9.75h2V5h6a1 1 0 1 0 0-2H4Zm14.18.94-.1-.09a.89.89 0 0 0-1.16.09l-8.25 8.23-.17 2.92v.13a.9.9 0 0 0 .89.78h3.05l8.27-8.26a.88.88 0 0 0 0-1.24l-2.53-2.56ZM3 20a1 1 0 0 0 1 1h1.5v-2H3v1Zm11.75-1h2.5v2h-2.5v-2Zm-4 0h2.5v2h-2.5v-2Zm-1.5 0h-2.5v2h2.5v-2ZM5 15.2v2.5H3v-2.5h2Zm14 0v2.5h2v-2.5h-2Zm2 4.8a1 1 0 0 1-1 1h-1.5v-2H21v1Z" />
      </svg>
    </IconWrap>
  );
};
StudioDraft.displayName = 'StudioDraft';

export default StudioDraft;
